'use strict';
const _ = require('underscore');
const Ajax = require('common/infra/ajax');

class API {
    constructor() {
        this._cursors = {};
        this._mores = {};
    }

    _getContentsPath(projectID, containerID) {
        return `/api/projects/${projectID}/data-containers/${containerID}/children`;
    }

    _getContentPath(projectID, contentID) {
        return `/api/projects/${projectID}/data-contents/${contentID}`;
    }

    createContent(projectID, containerID, contentJSON) {
        const path = this._getContentsPath(projectID, containerID);
        return Ajax.POST(path, contentJSON)
    }

    updateContent(projectID, contentID, contentJSON) {
        const path = this._getContentPath(projectID, contentID);
        return Ajax.PUT(path, contentJSON);
    }

    deleteContent(projectID, contentID) {
        const path = this._getContentPath(projectID, contentID);
        return Ajax.DELETE(path);
    }

    /**
     * Container 配下の Container/Contents を取得する
     *
     * @param projectID
     * @param contentID
     * @param option - {noRaise: true} を設定すると、NotFound (404) を無視します
     * @returns {*}
     */
    fetchContent(projectID, contentID, option) {
        const path = this._getContentPath(projectID, contentID);
        return Ajax.GET(path, option);
    }

    /**
     * Container 配下の Container/Contents を取得する
     *
     * @param projectID
     * @param containerID
     * @param limit
     * @param cursor
     * @returns {*}
     */
    fetchContents(projectID, containerID, limit, cursor) {
        let path = this._getContentsPath(projectID, containerID);
        path += `?limit=${limit}`;
        if(cursor) {
            path += `&cursor=${cursor}`;
        }

        return Ajax.GET(path)
            .then(value => {
                return value;
            })
    }
}

module.exports = new API();



// WEBPACK FOOTER //
// ./data/infra/api/content/index.js